import { getUserAgentRegex } from 'browserslist-useragent-regexp';

(function () {
    function setup() {
        checkBrowserVersion();
    }

    function checkBrowserVersion() {
        const userAgentString = navigator.userAgent;
        console.log(userAgentString);
        const modernBrowsers = getUserAgentRegex({
            browsers: 'last 2 versions, not dead, > 0.2%',
            allowHigherVersions: true,
            allowZeroSubverions: true
        });
        if (!modernBrowsers.test(userAgentString)) {
            // Show a warning message to the user
            const pageContent = $('.page__content');
            let div;
            if ($('.block--announcements').length === 0) {
                div = document.createElement('section');
                div.className = "block block--announcements";
                pageContent.prepend(div);
            } else {
                div = $('.block--announcements')[0];
            }
            let item = document.createElement('div');
            item.className = "text--center block--announcement--item";
            let text1 = gettext("Browser update recommended.");
            let text2 = gettext("For an optimal experience, please ensure that your browser is up to date. Site performance may be reduced with outdated versions, which may result in slowdowns or malfunctions.");
            item.innerHTML = '<p>' + text1 + '</p><p>' + text2 + '</p>';
            div.appendChild(item);
        }
    }
    setup();
})();